import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./ArticleCategories.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import CategoryIcon from '@mui/icons-material/Category';
import {useCommonContext} from "../../contexts/CommonContext";
import ButtonType from "../../ui_components/Button/ButtonType";
import ArticleCategoryStore from './ArticleCategoryStore';
import ArticleCategoryRow from './ArticleCategoryRow/ArticleCategoryRow';
import NewArticleCategoryButton from '../../shared_components/Buttons/NewArticleCategory/NewArticleCategoryButton';
import AllowAccess from '../../shared_components/Access/AllowAccess/AllowAccess';
import Access from '../../shared_components/Access/AllowAccess/Access';


const ArticleCategories: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const articleCategoryStore = new ArticleCategoryStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        articleCategoryStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await articleCategoryStore.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await articleCategoryStore.goToPage(page, pageSize);
    }


    return (
        <Observer>
            {() => (
                <div className={classes.article_categories_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        <div></div>
                        <AllowAccess any={[Access.CREATE_ARTICLE_CATEGORY]}>
                            <NewArticleCategoryButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                        </AllowAccess>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={articleCategoryStore.filter}
                                     placeholder={i18n.translate("ARTICLE_CATEGORY_FILTER_PLACEHOLDER")}
                                     onChange={(value) => {
                                        articleCategoryStore.setFilter(value)
                                     }} onEnter={() => articleCategoryStore.search()}/>
                        <Button
                            onClick={() => {
                                articleCategoryStore.search()
                            }}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>
                    {!articleCategoryStore.isEmpty &&
                    <div className={classes.article_categories_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={i18n.translate("ARTICLE_CATEGORIES")}
                                        pagination={articleCategoryStore.pagination}/>
                        <div className={classes.elements_container}>
                            {articleCategoryStore.articleCategories.map((articleCategory, i) => (
                                <ArticleCategoryRow
                                    onUpdate={onUpdate}
                                    articleCategory={articleCategory} key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={i18n.translate("ARTICLE_CATEGORIES")}
                            pagination={articleCategoryStore.pagination}/>
                    </div>}
                    {articleCategoryStore.isEmpty &&
                    <MessageCard icon={CategoryIcon} title={i18n.translate("NO_ARTICLE_CATEGORIES_TITLE")}
                                 subtitle={i18n.translate("NO_ARTICLE_CATEGORIES_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default ArticleCategories;

